import {BookLanguage} from '../../BookType'

export default interface LanguageReadingSpeedResponse {
	averagePagesPerHour: number | null
	languages: LanguageReadingSpeed[]
}

export interface LanguageReadingSpeed {
	language: BookLanguage
	pagesPerHour: number
	differencePercent: number
	bookCount: number
	totalReadPage: number
	totalReadTimeInMinutes: number
	native: NativeComparison | null
}

export interface NativeComparison {
	unit: 'WORD' | 'CHARACTER'
	estimatedUnitsPerMinute: number
	nativeUnitsPerMinute: number
	differencePercent: number
	unitsPerPage: number
	source: string
}

// 원어민 평균(분당 단어/글자)을 1쪽당 단위 수로 나눠 시간당 쪽수로 환산
export const getNativePagesPerHour = (native: NativeComparison): number => native.nativeUnitsPerMinute * 60 / native.unitsPerPage

// 원어민(또는 내) 평균 대비 몇 배인지: differencePercent 30 → 1.3, -20 → 0.8 (소수 첫째 자리)
const getSpeedRatio = (differencePercent: number): number => parseFloat((1 + differencePercent / 100).toFixed(1))

// 0.9~1.1배는 비슷하다고 봄
export type SpeedTone = 'faster' | 'similar' | 'slower'

export const getSpeedTone = (differencePercent: number): SpeedTone => {
	const ratio = getSpeedRatio(differencePercent)
	if (ratio > 1.1) return 'faster'
	if (ratio < 0.9) return 'slower'
	return 'similar'
}

// "1.3배", "0.8배"
export const formatSpeedDifference = (differencePercent: number): string => `${getSpeedRatio(differencePercent)}배`

// "1.3배 빨라요", "0.8배 속도예요", "비슷해요"
export const formatSpeedComparison = (differencePercent: number): string => {
	const ratio = getSpeedRatio(differencePercent)
	const tone = getSpeedTone(differencePercent)
	if (tone === 'similar') return '비슷해요'
	return tone === 'faster' ? `${ratio}배 빨라요` : `${ratio}배 속도예요`
}
